import { Component, OnInit, Input } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { LgvAPIService } from '../../core/services/lgv-api.service';
import { LgvSettingsService } from '../../core/core.module';
import { LgvModel } from '../../data-models/longevity.model';
import { map, first } from 'rxjs/operators';

@Component({
    selector: 'lgv-agent-partner-row',
    templateUrl: 'agent-partner-row.component.html',
})

export class AgentPartnerRow implements OnInit{

    constructor(public LgvAPI: LgvAPIService, public LgvSettingsService: LgvSettingsService) { }

    ngOnInit() {

    }
}
